import axios from 'axios';
import { urlAPI } from '../configurations/constantes';
import { detectarBrowser, detectarSistemaOperacional } from '../utils';
import { PerfilUsuarioEnum } from '../enums';

class LogService {
    static registrarAcesso = (codigoPagina, codigoFuncionalidade) => {
        const ud = JSON.parse(localStorage.getItem('user_data'));
        const codigoPerfil = PerfilUsuarioEnum.properties[ud.role].codigo;
        const sistemaOperacional = detectarSistemaOperacional();
        const navegador = detectarBrowser();

        axios.post(`${urlAPI}/cust/${ud.codigoEmpresa}/acessos?paginaSite=${codigoPagina}&funcionalidade=${codigoFuncionalidade}&sistemaOperacional=${sistemaOperacional}&navegador=${navegador}&codigoPerfil=${codigoPerfil}`)
            .catch((error) => {
                console.log(error);
            });
    };
}

export default LogService;